/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import loadingIcon from "../../../../assets/icons/loading.svg";
import { SvgHandler } from "../../svg-handler/svg-handler";
import "./loader-overlay.module.css";

const LoaderOverlay = props => {
  return (
    <div styleName="container">
      <SvgHandler clazzName="loader" xlinkHref={loadingIcon} />
    </div>
  );
};

export default LoaderOverlay;
